module.exports = __webpack_public_path__ + "static/media/children_ny_thumb.25811385.jpg";